import elliemaeApi from './interceptors/elliemaeApi';

const getEmploymentUrl = (loanId, applicationId, type) =>
    `/encompass/v3/loans/${loanId}/applications/${applicationId}/${type}/employment`;

export const fetchEmployment = async (token, loanId, applicationId, type) => {
    const url = getEmploymentUrl(loanId, applicationId, type);
    const config = {
        method: 'get',
        url,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    };
    const res = await elliemaeApi.request(config);
    return res.data || [];
};

export const submitEmployment = async ({
    token,
    loanId,
    applicationId,
    borrowerEmployment,
    coborrowerEmployment
}) => {
    const borrowerExisting = await fetchEmployment(token, loanId, applicationId, 'borrower');
    const coborrowerExisting = await fetchEmployment(token, loanId, applicationId, 'coborrower');

    const classify = (newData, existingData) => {
        if (!newData?.length) return { add: [], update: [] };
        const add = [];
        const update = [];

        for (const entry of newData) {
            const match = existingData.find(e => e.currentEmploymentIndicator);
            if (match) {
                update.push({ ...entry, id: match.id });
            } else {
                add.push(entry);
            }
        }
        return { add, update };
    };

    const { add: borrowerAdd, update: borrowerUpdate } = classify(borrowerEmployment, borrowerExisting);
    const { add: coborrowerAdd, update: coborrowerUpdate } = classify(coborrowerEmployment, coborrowerExisting);

    const post = async (type, action, data) => {
        const url = `${getEmploymentUrl(loanId, applicationId, type)}?action=${action}&view=entity`;
        await elliemaeApi.patch(url, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
    };

    if (borrowerAdd.length) await post('borrower', 'add', borrowerAdd);
    if (borrowerUpdate.length) await post('borrower', 'update', borrowerUpdate);
    if (coborrowerAdd.length) await post('coborrower', 'add', coborrowerAdd);
    if (coborrowerUpdate.length) await post('coborrower', 'update', coborrowerUpdate);
};